import { Client } from "../client/client";
import { Fornecedor } from "../fornecedor/fornecedor";

export class Estoque {
    id: number;
    product: any;
    supplier: any;
    qdtProduct: any;
    amountPaid: any;
    invoiceNumber: string;
    obser: string;
    fornecedor: string;
    produto: string;
    createdAt: any;
    
    constructor(id: number, product: any, supplier: any, qdtProduct: any, amountPaid: any,invoiceNumber: string, 
        obser: string,fornecedor: string,
        produto: string,createdAt: any) {
        this.id = id;
        this.product = product;
        this.supplier = supplier;
        this.qdtProduct = qdtProduct;
        this.amountPaid = amountPaid;
        this.invoiceNumber = invoiceNumber;
        this.obser = obser;
        this.fornecedor = fornecedor;
        this.produto = produto;
        this.createdAt = createdAt;
    }
}